<div
    class="card dynamic-task-card"
    [ngClass]="{
        'dynamic-collecting-card': !isDone,
        'dynamic-done-card': isDone,
        'dynamic-card-expanded': !isCollapsed
    }"
    [ngStyle]="{
        border:
            !isDone && task.multipickingTaskIdentifierColor
                ? '2px solid ' + task.multipickingTaskIdentifierColor
                : 'none'
    }"
>
    <span
        *ngIf="badgeText && !groupCollapsed"
        class="dynamic-sequence-number"
        aria-hidden="true"
    >
        {{ badgeText }}
    </span>
    <div class="card-header" (click)="toggleCard()">
        <div class="dynamic-task-selector">
            <span *ngIf="isDone" class="dynamic-completed-check">
                <i class="fa fa-check"></i>
            </span>
            <input
                *ngIf="!isDone && maximumMultipickingTasks > 1"
                type="checkbox"
                [checked]="isMultiPickingSelectedTask"
                [disabled]="isMultipickingSelectionDisabled"
                (click)="$event.stopPropagation()"
                (change)="changed($event)"
            />
        </div>
        <div class="dynamic-task-summary">
            <div class="dynamic-task-title">
                #{{ task.orderCode }} &middot; {{ task.customerZipCode }},
                {{ task.providerName }}, {{ task.orderItemNumber }} SKU
            </div>
            <div
                *ngIf="task.deliveryTimeSlot || task.calculatedPriceEnabled"
                class="dynamic-task-metadata"
            >
                <span
                    *ngIf="task.deliveryTimeSlot"
                    class="dynamic-task-meta dynamic-task-timeslot"
                    [attr.title]="'my-tasks.delivery-deadline' | translate"
                >
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    {{ task.deliveryTimeSlot }}
                </span>
                <span *ngIf="task.calculatedPriceEnabled" class="dynamic-task-meta">
                    <i class="fa fa-money" aria-hidden="true"></i>
                    {{ task.calculatedPrice }} {{ 'common.currency' | translate }}
                </span>
            </div>
        </div>
        <span *ngIf="isDone" class="dynamic-done-label">
            {{ 'my-tasks.done' | translate }}
        </span>
        <div *ngIf="!isDone" class="dynamic-task-actions">
            <button
                type="button"
                class="btn dynamic-icon-button dynamic-info-button"
                *ngIf="task.calculatedPriceEnabled"
                (click)="showCalculatedPriceInfoModal($event)"
                aria-label="Information"
            >
                <i class="fa fa-dot-circle-o"></i>
            </button>
            <button
                type="button"
                class="btn dynamic-icon-button dynamic-list-button"
                (click)="showProductListModal($event)"
                [attr.aria-label]="'my-tasks.product-list' | translate"
            >
                <i class="fa fa-list-ul"></i>
            </button>
        </div>
        <div
            class="dynamic-multi-picking-identifier"
            *ngIf="task.multipickingTaskIdentifierChar"
            [ngStyle]="{
                'background-color': task.multipickingTaskIdentifierColor
            }"
        >
            {{ task.multipickingTaskIdentifierChar }}
        </div>
    </div>

    <div
        *ngIf="!isDone"
        class="card-body dynamic-task-details text-center"
        [collapse]="isCollapsed"
        [isAnimated]="true"
    >
        <h5 class="card-title">{{ task.customerName }}</h5>
        <div class="table-responsive dynamic-task-details-table">
            <table class="table table-striped table-borderless text-white">
                <tbody>
                    <tr>
                        <th scope="row">{{ 'common.provider-shop' | translate }}:</th>
                        <td>
                            <a
                                href="http://maps.google.com/maps?q={{
                                    task.providerShop
                                }}"
                                class="text-white"
                                target="_blank"
                            >
                                <u>{{ task.providerShop }}</u>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">{{ 'common.payment-type' | translate }}:</th>
                        <td>
                            {{
                                'payment-type.' +
                                    PaymentType[task.paymentType].toLowerCase()
                                    | translate
                            }}
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">{{ 'common.phone' | translate }}:</th>
                        <td>
                            <a href="tel:{{ task.customerPhone }}" class="text-white">
                                <u>{{ task.customerPhone }}</u>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            {{ 'my-tasks.customer-zip-code' | translate }}:
                        </th>
                        <td>{{ task.customerZipCode }}</td>
                    </tr>
                    <tr>
                        <th scope="row">{{ 'my-tasks.order-code' | translate }}:</th>
                        <td>{{ task.orderCode }}</td>
                    </tr>
                    <tr>
                        <th scope="row">
                            {{ 'my-tasks.delivery-deadline' | translate }}:
                        </th>
                        <td>
                            <span>{{
                                task.deliveryDeadline
                                    | amAdd : task.timeSlotVisualShiftMinutes : 'minutes'
                                    | amDateFormat : 'HH:mm'
                            }}</span>
                            <span *ngIf="task.deliveryTimeSlotEnd != null">
                                -
                                {{
                                    task.deliveryDeadline
                                        | amAdd
                                            : task.deliveryTimeSlotEnd +
                                                  task.timeSlotVisualShiftMinutes
                                            : 'minutes'
                                        | amDateFormat : 'HH:mm'
                                }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">{{ 'my-tasks.bag' | translate }}:</th>
                        <td *ngIf="task.usePaperBag; else multiUseBag">
                            {{ 'my-tasks.paper-bag' | translate }}
                        </td>
                        <ng-template #multiUseBag>
                            <td *ngIf="task.usePaperBag === false">
                                {{ 'my-tasks.multiuse-bag' | translate }}
                            </td>
                        </ng-template>
                    </tr>
                    <tr>
                        <th scope="row">{{ 'common.notes' | translate }}:</th>
                        <td>{{ task.notes }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <app-deliverer-notes
            [isVisible]="isDelivererNotesVisible"
            [orderID]="task.orderID"
            [delivererNotes]="task.delivererNotes"
        ></app-deliverer-notes>
    </div>
    <div *ngIf="!isDone" [collapse]="isCollapsed" [isAnimated]="true">
        <app-wish-list-buttons
            [orderCode]="task.orderCode"
            [customerPhone]="task.customerPhone"
            [wishListOrders]="task.wishListOrders"
        ></app-wish-list-buttons>
    </div>
    <div *ngIf="!isDone" class="card-footer" [collapse]="isCollapsed" [isAnimated]="true">
        <app-collecting-task-button [task]="task"></app-collecting-task-button>
    </div>
</div>
